export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const SET_LOGGED_IN_AS_USER = 'SET_LOGGED_IN_AS_USER';
export const REMOVE_LOGGED_IN_AS_USER = 'REMOVE_LOGGED_IN_AS_USER';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
